export const generateStars = (count, input, maxSizeStar) => {
    const stars = [];
    for (let i = 0; i < count; i++) {
        const maxSize = maxSizeStar || 20;
        const additional = input ? 0 : 5;
        const size = input ? Math.random() * 2 + 0.5 : Math.random() * (maxSize - 5) + additional;
        const left = Math.random() * 100;
        const top = Math.random() * 100;
        const starType = Math.floor(Math.random() * 4) + 1;
        const animationDuration = input ? 0.1 : Math.random() * 20 + 20;
        const animationDelay = input ? 0.1 : Math.random() * 5;
        stars.push({ size, left, top, starType, animationDuration, animationDelay });
    }
    return stars;
};
